/** Retrato do pong e do quadro. Não importa o motor nem o hub. */

export type SaudeMundo = 0 | 1 | 2;

export interface DesempenhoSnap {
  esperaMs: number;
  saude: SaudeMundo;
  salaP99: number;
  fps: number;
  overlay: boolean;
}

let esperaMs = 0;
let saude: SaudeMundo = 0;
let salaP99 = 0;
let overlay = false;
let fps = 0;
let quadros = 0;
let fpsEm = 0;

export function anotarPong(espera: number, s: number, p99Decimos: number) {
  esperaMs = Number.isFinite(espera) ? espera : 0;
  saude = s === 2 ? 2 : s === 1 ? 1 : 0;
  salaP99 = Number.isFinite(p99Decimos) ? p99Decimos : 0;
}

export function marcarQuadro() {
  const agora = performance.now();
  if (fpsEm === 0) fpsEm = agora;
  quadros++;
  const dt = agora - fpsEm;
  if (dt >= 500) {
    fps = quadros * 1000 / dt;
    quadros = 0;
    fpsEm = agora;
  }
}

export function setOverlay(aberto: boolean) {
  overlay = aberto;
}

export function overlayAberto() {
  return overlay;
}

export function ler(): DesempenhoSnap {
  return { esperaMs, saude, salaP99, fps, overlay };
}

export function palavra(s: SaudeMundo) {
  if (s === 2) return 'sobrecarregado';
  if (s === 1) return 'carregado';
  return 'estável';
}
